export class PollingTimer {
  hook = async () => true;
  interval = 2000;
  timer: any = null;
  stopped = false;

  constructor(hook, interval = 2000) {
    this.hook = hook;
    this.interval = interval;
  }

  start() {
    this.stopped = false;
    return new Promise((resolve) => {
      const step = async (cb) => {
        const res = await this.hook();
        if (this.stopped) return;
        if (res) {
          cb(res);
        } else if (res !== undefined) {
          clearTimeout(this.timer);
          this.timer = setTimeout(step, this.interval, cb);
        } else {
          cb(false);
        }
      };
      step(resolve);
    });
  }

  cancel() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
      this.stopped = true;
    }
  }
}
